import { conditionMessages } from './condition-messages.js'
import { enumOptionsId } from './enum-options.js'
import { sectionCatalogId } from './section-catalog.js'

export const id = {
  visualGameStudio: {
    brand: 'Visual Game Studio',
    localizationUnsupported: 'Versi lama ini tidak memiliki data kompilasi lengkap dan tidak dapat dilokalkan. Pilih versi lain.',
    seal: 'VG',
    viewport: {
      title: 'Gunakan layar yang lebih besar',
      body: 'Visual Game Studio adalah alat authoring desktop. Gunakan layar minimal 1024px untuk mengedit pack.',
    },
    nav: { projects: 'Proyek', editor: 'Editor', assets: 'Aset', versions: 'Versi', turnVideos: 'Video giliran', runChain: 'Rantai permainan', localization: 'Bahasa', help: 'Bantuan', settings: 'Pengaturan' },
    auth: { title: 'Masuk Studio', subtitle: 'Gunakan akun platform untuk mengelola cerita, aset, versi, dan rilis.', email: 'Email', password: 'Kata sandi', login: 'Masuk', logout: 'Keluar', loggingIn: 'Masuk', failed: 'Gagal masuk' },
    topbar: { preview: 'Pratinjau', publish: 'Rilis', noProject: 'Belum memilih proyek', account: 'Akun', themeLight: 'Tema terang', themeDark: 'Tema gelap' },
    projects: {
      title: 'Proyek saya',
      subtitle: 'Kelola draf visual-game, status rilis, dan visibilitas.',
      tags: 'Tag', bulkTags: 'Tag massal', bulkTagsPlaceholder: 'Fantasi, Romansa, Misteri', applyToFiltered: 'Terapkan ke {count} hasil', bulkTagsApplied: 'Tag diperbarui pada {count} naskah',
      newProject: 'Proyek baru',
      search: 'Cari proyek',
      filterAll: 'Semua',
      filterDraft: 'Draf',
      filterPublished: 'Dirilis',
      sortUpdated: 'Terbaru',
      sortEpisode: 'Urutan level',
      levelNumber: 'Level {number}',
      emptyTitle: 'Belum ada proyek',
      emptyBody: 'Buat pack pertama dan masuk ke editor terstruktur.',
      edit: 'Edit',
      duplicate: 'Duplikasi',
      rename: 'Ganti nama',
      visibility: 'Visibilitas',
      delete: 'Arsip/Hapus',
      createTitle: 'Proyek baru',
      editTitle: 'Edit proyek',
      projectTitle: 'Judul',
      seriesId: 'ID seri',
      seriesIdPlaceholder: 'mis. painted_skin',
      seriesTitle: 'Judul seri',
      scriptTitle: 'Judul cerita',
      seriesTitlePlaceholder: 'mis. Painted Skin',
      episodeNo: 'Nomor level',
      episodeNoPlaceholder: '1',
      seriesHint: 'Kosongkan ketiganya untuk level mandiri. Untuk seri, isi ketiganya dan gunakan nomor level yang unik.',
      newSeries: 'Cerita baru',
      createSeries: 'Buat cerita',
      createSeriesTitle: 'Cerita baru',
      createSeriesHint: 'Membuat cerita juga membuat level pertamanya. Level lain dapat ditambahkan setelahnya.',
      firstLevelTitle: 'Judul level pertama',
      firstLevelTitlePlaceholder: 'mis. Masuk ke kuil',
      seriesCreated: 'Cerita dan level pertama dibuat',
      seriesSection: 'Cerita',
      standaloneSection: 'Level mandiri',
      manageLevels: 'Kelola level',
      levelCount: '{count} level',
      newLevel: 'Level baru',
      newStandalone: 'Level mandiri baru',
      backToSeries: 'Kembali ke daftar cerita',
      seriesLevelsSubtitle: 'Kelola {count} level dalam cerita ini secara berurutan.',
      belongsToSeries: 'Cerita',
      searchLevels: 'Cari level dalam cerita ini',
      searchStandalone: 'Cari level mandiri',
      noMatchingLevels: 'Tidak ada level yang cocok',
      locale: 'Bahasa',
      associateLevel: 'Tautkan level yang ada',
      associateLevelTitle: 'Tautkan level mandiri',
      associateLevelHint: 'Pindahkan level mandiri asli ke {series} tanpa membuat salinan atau mengubah isinya.',
      standaloneLevel: 'Level mandiri',
      selectStandaloneLevel: 'Pilih level mandiri',
      levelAssociated: 'Level ditautkan ke cerita',
      associateLevelFailed: 'Gagal menautkan level',
      private: 'Privat',
      public: 'Publik',
      unlisted: 'Tidak terdaftar',
      save: 'Simpan',
      cancel: 'Batal',
      creating: 'Membuat',
      saving: 'Menyimpan',
      loading: 'Memuat proyek',
      loadFailed: 'Gagal memuat proyek',
      createFailed: 'Gagal membuat',
      updateFailed: 'Gagal menyimpan',
      duplicateFailed: 'Gagal menduplikasi',
      deleteFailed: 'Gagal menghapus',
      created: 'Proyek dibuat',
      updated: 'Proyek disimpan',
      duplicated: 'Proyek diduplikasi',
      archived: 'Proyek diarsipkan',
      deleted: 'Proyek dihapus',
      confirmDelete: 'Konfirmasi tindakan ini. Pack yang sudah dirilis atau memiliki data pengguna akan diarsipkan; draf tanpa relasi akan dihapus permanen.',
      confirmTextLabel: 'Ketik {title} untuk mengonfirmasi',
      scenes: 'Adegan',
      endings: 'Akhir',
      updatedAt: 'Diperbarui',
    },
    status: { draft: 'DRAFT', published: 'PUBLISHED', archived: 'ARCHIVED', unknown: 'UNKNOWN' },
    enumOptions: enumOptionsId,
    sectionGroups: { basic: 'Dasar', state: 'Stat & status', world: 'Dunia', cast: 'Tokoh & objek', info: 'Info', gameplay: 'Gameplay', ending: 'Ending', assets: 'Aset' },
    editor: {
      title: 'Editor cerita',
      subtitle: 'Kelola peta, tokoh, quest, aturan, ending, dan media per bagian.',
      section: 'Bagian',
      readonly: 'Anda tidak punya izin mengedit proyek ini',
      unsaved: 'Belum disimpan',
      saved: 'Tersimpan',
      save: 'Simpan',
      revert: 'Kembalikan',
      savedToast: 'Bagian disimpan',
      saveFailed: 'Gagal menyimpan',
      discardConfirm: 'Ada perubahan belum disimpan. Buang?',
      discardTitle: 'Buang perubahan belum disimpan',
      discardBody: 'Section ini memiliki perubahan yang belum disimpan. Jika keluar sekarang, data tidak akan ditulis ke database.',
      stayEditing: 'Lanjut edit',
      discardCta: 'Buang perubahan',
      deleteEntityTitle: 'Hapus item',
      deleteEntityBody: 'Item ini akan dihapus dari section saat ini dan ditulis ke database setelah disimpan.',
      deleteEntityBlocked: 'Item ini dipakai di {count} tempat. Hapus referensi tersebut sebelum menghapus item.',
      deleteEntityConfirmLabel: 'Ketik {label} untuk mengonfirmasi penghapusan.',
      deleteEntityCta: 'Hapus item',
      recentChanges: 'Perubahan terbaru',
      recentChangesHint: 'Menampilkan catatan audit database untuk draf ini.',
      auditLoading: 'Memuat perubahan',
      auditLoadFailed: 'Gagal memuat perubahan',
      noRecentChanges: 'Belum ada perubahan',
      auditActions: { section_update: 'Section disimpan', asset_upload: 'Aset diunggah', asset_delete: 'Aset dihapus', compile: 'Dikompilasi', publish: 'Dirilis', rollback: 'Rollback' },
      focusedCheck: 'Cek publish terarah',
      structuredTab: 'Terstruktur',
      jsonTab: 'JSON',
      jsonHelp: 'Perubahan JSON disinkronkan ke formulir setelah valid.',
      jsonInvalid: 'JSON tidak valid',
      addRow: 'Tambah',
      searchOptions: 'Search options',
      dragRow: 'Seret untuk mengurutkan',
      duplicateRow: 'Duplikasi',
      removeRow: 'Hapus',
      emptyRows: 'Belum ada baris',
      item: 'Item',
      noId: 'Tanpa ID',
      sections: {
        mapLocations: 'Lokasi',
        mapGraph: 'Graf lokasi',
        npcs: 'NPC',
        objects: 'Objek',
        clues: 'Petunjuk',
        conclusions: 'Kesimpulan',
        infoBlocks: 'Blok info',
        sceneEvents: 'Event adegan',
        actionRules: 'Aturan aksi',
        endings: 'Ending',
        stateRegistry: 'Registry status',
        players: 'Karakter pemain',
        quests: 'Quest',
        mediaTags: 'Tag media',
        videoReferences: 'Referensi pembuatan video',
        stageRules: 'Aturan stage',
        audioRules: 'Aturan audio',
        voiceSettings: 'Pengaturan suara',
        voiceSettingsHelp: 'Atur suara default terlebih dahulu; tiap kolom bahasa dapat menggantinya, dan nilai kosong mengikuti default.',
        audioMoodRules: 'Aturan BGM',
        statSfxRules: 'SFX stat',
        stateCgRules: 'Aturan CG status',
        followupRules: 'CG lanjutan',
      },
      stateWorkspace: {
        initialTitle: 'Nilai awal',
        initialBody: 'Saat run baru dibuat, nilai ini ditulis ke run: flag global, status NPC, progres quest, status objek, dan inventaris awal.',
        registryTitle: 'Registry status',
        registryBody: 'Ini lembar referensi untuk key status. Isinya arti setiap key, siapa yang menulis, siapa yang membaca, dan cerita atau aturan yang terdampak.',
        relationshipTitle: 'Hubungan',
        relationshipBody: 'Nilai awal menentukan apa yang benar saat mulai. Registry menjelaskan arti key. Registry tidak menggantikan nilai awal; ia membantu cek publish, referensi aturan, dan pemeliharaan.',
        openingValues: 'Nilai awal',
        registeredKeys: 'Key terdaftar',
        initialHint: 'Simpan hanya nilai yang wajib ada saat mulai. Status NPC dan objek bertingkat ditampilkan sebagai path titik agar sejajar dengan key registry.',
        registryHint: 'Daftarkan setiap key yang dibaca aturan aksi, kondisi, KP, atau agent. Sumber dan dampak yang jelas memudahkan debugging nanti.',
        registryTableTitle: 'Entri registry status',
        unregisteredInitialKeys: 'Key awal ini belum memiliki catatan registry:',
        keyPurpose: 'Tujuan',
        noRegistryNote: 'Tujuan belum terdaftar',
        noRegistryHint: 'Tambahkan key yang sama di registry status di bawah agar arti dan dampak runtime muncul di sini.',
      },
      sceneWorkspace: {
        scenesGroup: 'Adegan',
        emptyScenes: 'Belum ada adegan. Tambahkan lokasi di Peta terlebih dahulu.',
        noScene: 'Buat adegan di Peta terlebih dahulu.',
        noDescription: 'Adegan ini belum memiliki deskripsi.',
        unlocked: 'Terbuka sejak awal',
        locked: 'Terkunci',
        sceneObjects: 'Definisi objek adegan',
        sceneClues: 'Petunjuk adegan',
        sceneInfoBlocks: 'Blok info adegan',
        sceneEvents: 'Event adegan',
        sceneActionRules: 'Aturan adegan',
        npcNote: 'Pilih NPC global yang muncul di adegan ini dan edit status awal adegannya. Profil lengkap tetap di definisi NPC global.',
        objectNote: 'Edit objek global yang dipasang di adegan ini. Definisi tersimpan ke objects global; penempatan ke map.locations[].objectIds.',
        clueNote: 'Tampilan ini memfilter petunjuk global untuk adegan saat ini. Petunjuk baru otomatis ditautkan ke adegan ini.',
        infoNote: 'Tampilan ini memfilter blok info berdasarkan NPC di adegan ini.',
        eventNote: 'Tampilan ini memfilter event untuk adegan saat ini. Saat disimpan, locationId menjadi adegan ini.',
        ruleNote: 'Tampilan ini memfilter aturan aksi untuk adegan saat ini. Aturan baru diberi kondisi location agar tidak menjadi aturan global.',
        tabs: {
          overview: 'Ringkasan',
          basic: 'Dasar',
          connections: 'Koneksi',
          npcs: 'NPC',
          objects: 'Objek',
          clues: 'Petunjuk',
          infoBlocks: 'Info',
          sceneEvents: 'Event',
          actionRules: 'Aturan',
        },
        hints: {
          basic: 'Nama, deskripsi, tipe, dan media adegan.',
          connections: 'Relasi perpindahan dari adegan ini ke adegan lain.',
          npcs: 'NPC yang hadir di adegan ini dan status awalnya.',
          objects: 'Objek global yang dipasang di adegan ini beserta definisinya.',
          clues: 'Petunjuk terkait adegan, NPC, atau objeknya.',
          infoBlocks: 'Info yang bisa dibuka dan fakta tersembunyi milik NPC adegan.',
          sceneEvents: 'Event masuk, penemuan, atau custom untuk adegan ini.',
          actionRules: 'Aturan terkait target adegan atau kondisi location.',
        },
      },
      mediaUsage: {
        title: 'Media usage',
        subtitle: 'Shows where each media asset is bound in the game flow. Saving writes these bindings into structured tables used by the game runtime.',
        missingAsset: 'This tag is missing from the asset manifest',
        opening: 'Home opening CG',
        endingBook: 'Ending book background',
        entryStage: 'Entry stage',
        entryStageIdle: 'Entry idle video',
        defaultStage: 'Default stage',
        defaultStageIdle: 'Default idle video',
        revealedStage: 'Revealed stage',
        revealedStageIdle: 'Revealed idle video',
        defaultBgm: 'Default BGM',
        editInMedia: 'Edit in Media global rules',
        editInMediaStageRules: 'Edit in Media stage rules',
        editInMediaAudioRules: 'Edit in Media audio rules',
        editInMediaStateCgs: 'Edit in Media state CG rules',
        editInMediaFollowups: 'Edit in Media follow-ups',
        editInMap: 'Edit in Map location media',
        editInNpcs: 'Edit in NPC media tag',
        editInPlayers: 'Edit in Player character portrait',
        editInEndings: 'Edit in Ending CG',
      },
      sectionCatalog: sectionCatalogId,
      fieldGroups: {
        public: 'Lapisan publik',
        secret: 'Lapisan rahasia',
        secretBadge: 'Rahasia · tersembunyi dari pemain',
      },
      fields: {
        id: 'ID',
        name: 'Nama',
        type: 'Tipe',
        state: 'Status',
        label: 'Label',
        scope: 'Scope',
        source: 'Sumber',
        detail: 'Detail',
        summary: 'Ringkasan',
        prerequisiteConclusions: 'Kesimpulan prasyarat',
        relatedClues: 'Petunjuk terkait',
        content: 'Konten',
        priority: 'Prioritas',
        target: 'Target',
        targetType: 'Tipe target',
        mode: 'Mode',
        intent: 'Intent',
        claim: 'Klaim',
        claims: 'Klaim semantik',
        mediaTag: 'Media tag',
        referenceAssets: 'Reference assets',
        stageMediaTags: 'Stage portraits',
        phaseKey: 'Stage',
        tag: 'Tag',
        file: 'File',
        objectKey: 'Object key',
        mime: 'MIME',
        width: 'Lebar',
        height: 'Tinggi',
        packId: 'Pack ID',
        title: 'Judul',
        tagline: 'Ringkasan',
        assetManifestId: 'Asset manifest ID',
        videoSceneReferenceTag: 'Gambar referensi adegan',
        videoNpcReferenceTag: 'Gambar referensi NPC',
        videoPlayerReferenceTag: 'Gambar referensi pemain',
        coverTag: 'Sampul horizontal (cadangan)',
        portrait_cover_tag: 'Sampul vertikal (9:16)',
        opening: 'Teks pembuka',
        seoTitle: 'Judul daftar',
        seoDescription: 'Ringkasan daftar',
        initialLocation: 'Lokasi awal',
        none: 'Kosong',
        initialPhase: 'Fase awal',
        turnLimit: 'Batas giliran',
        openingStrategy: 'Strategi awal',
        defaultActionMode: 'Mode aksi default',
        statsDefinitions: 'Definisi stat',
        statId: 'ID',
        statName: 'Nama',
        statColor: 'Warna',
        initialValue: 'Awal',
        description: 'Deskripsi',
        statRules: 'Aturan stat',
        initialStates: 'Status awal',
        stateKey: 'Kunci status',
        stateValue: 'Nilai status',
        initialFlags: 'Flags awal',
        initialNpcStates: 'Status NPC awal',
        initialQuestStates: 'Status quest awal',
        initialSceneEventStates: 'Event awal',
        initialObjectStates: 'Status objek awal',
        initialInventory: 'Inventaris awal',
        primaryNpcId: 'NPC utama',
        keeperRole: 'Peran KP',
        dynamicStoryEnabled: 'Aktifkan cerita dinamis',
        singleScene: 'Mode satu adegan',
        minDistinctTurns: 'Minimum giliran berbeda',
        maxActiveBranches: 'Maksimum cabang aktif',
        maxGeneratedEndings: 'Ending buatan per run',
        trackerExpiry: 'Giliran kedaluwarsa alur',
        dynamicStoryPrinciples: 'Prinsip cerita dinamis',
        dynamicStoryForbidden: 'Batas cerita dinamis',
        referenceEndings: 'Ending referensi',
        referenceEndingsHint: 'Contoh hanya diberikan kepada perancang cabang, bukan prompt KP atau NPC biasa.',
        referenceEnding: 'Ending referensi',
        requiredConsequences: 'Konsekuensi wajib',
        phaseRules: 'Aturan fase',
        phase: 'Fase',
        principles: 'Prinsip',
        forbidden: 'Aturan terlarang',
        hiddenFacts: 'Fakta tersembunyi',
        displayName: 'Nama tampilan',
        publicProfile: 'Profil publik',
        trueProfile: 'Profil asli',
        coverRole: 'Peran samaran',
        coverStory: 'Cerita samaran',
        coverAttitude: 'Sikap samaran',
        species: 'Spesies',
        origin: 'Asal',
        hunger: 'Hasrat',
        limitation: 'Batasan',
        danger: 'Bahaya',
        appearance: 'Penampilan',
        publicKnowledge: 'Pengetahuan publik',
        privateKnowledge: 'Pengetahuan privat',
        disclosePolicy: 'Kebijakan pengungkapan',
        boundaries: 'Batas',
        mustDo: 'Harus dilakukan',
        mustNotDo: 'Tidak boleh dilakukan',
        usable: 'Bisa dipakai',
        damaged: 'Rusak',
        known: 'Diketahui',
        importance: 'Kepentingan',
        ownerNpc: 'Owner NPC',
        startsUnlocked: 'Terbuka sejak awal',
        unlockWhen: 'Kondisi buka',
        speakableAs: 'Kalimat',
        locationId: 'ID lokasi',
        once: 'Sekali',
        triggerWhen: 'Kondisi pemicu',
        whenCondition: 'Kondisi cocok',
        requires: 'Syarat',
        invalidReason: 'Alasan tidak valid',
        overrideKp: 'Override KP',
        stopProcessing: 'Hentikan proses',
        targetsAll: 'Semua target',
        effectsStats: 'Perubahan stat',
        effectsFlags: 'Flag yang disetel',
        effectsEvidence: 'Bukti ditambahkan',
        locationChange: 'Pindah lokasi',
        unlockLocations: 'Buka lokasi',
        lockLocations: 'Kunci lokasi',
        addInventory: 'Tambah inventaris',
        removeInventory: 'Hapus inventaris',
        sceneNarration: 'Narasi adegan',
        visibleFindings: 'Temuan terlihat',
        discoveredObjects: 'Objek ditemukan',
        npcReaction: 'Kebijakan reaksi NPC',
        npcDirectiveNpc: 'NPC arahan',
        npcDirectiveTactic: 'Taktik NPC',
        npcDirectiveMood: 'Mood NPC',
        mustReactTo: 'Harus bereaksi',
        mustHide: 'Harus sembunyikan',
        possibleEnding: 'Ending langsung',
        reason: 'Alasan',
        valueType: 'Tipe nilai',
        hardState: 'Hard state',
        writers: 'Penulis',
        readers: 'Pembaca',
        runtimeEffect: 'Efek runtime',
        notes: 'Catatan',
        npcIds: 'NPC IDs',
        objectIds: 'Object IDs',
        sceneEventIds: 'Event IDs',
        connections: 'Koneksi',
        to: 'Ke',
        locked: 'Terkunci',
        lockedReason: 'Alasan terkunci',
        defaultCharacterId: 'Karakter default',
        showInSelection: 'Tampilkan di pemilihan karakter',
        gender: 'Gender',
        age: 'Umur',
        archetype: 'Arketipe',
        portraitTag: 'Media potret',
        attributes: 'Atribut',
        skills: 'Skill',
        inventory: 'Inventaris',
        history: 'Riwayat',
        traits: 'Trait',
        mainQuestId: 'Quest utama',
        statusAtStart: 'Status awal',
        steps: 'Langkah',
        completeWhen: 'Kondisi selesai',
        failWhen: 'Kondisi gagal',
        entryTag: 'Entry tag',
        entryIdleTag: 'Entry idle tag',
        defaultTag: 'Default tag',
        defaultIdleTag: 'Default idle tag',
        revealedTag: 'Revealed tag',
        revealedIdleTag: 'Revealed idle tag',
        openingTag: 'Opening CG tag',
        endingBookTag: 'Ending book tag',
        idleTag: 'Idle video tag',
        mood: 'Mood',
        statKey: 'Stat key',
        triggerType: 'Trigger type',
        statePath: 'State path',
        threshold: 'Threshold',
        oncePerRun: 'Once per run',
        triggerScope: 'Trigger scope',
        sortOrder: 'Sort order',
        defaultBgmTag: 'Default BGM tag',
        defaultBgmMood: 'Default BGM mood',
        voiceRole: 'Peran',
        defaultVoice: 'Suara default',
        inheritDefaultVoice: 'Ikuti default',
        playerVoiceId: 'Suara pemain',
        npcVoiceId: 'Suara NPC',
        endingVoiceId: 'Suara akhir',
      },
    },
    conditions: conditionMessages.id,
    assets: {
      title: 'Aset',
      subtitle: 'Kelola potret, CG, audio, dan referensi.',
      file: 'File',
      search: 'Cari tag, MIME, atau object key',
      upload: 'Unggah aset',
      uploading: 'Mengunggah',
      uploaded: 'Aset diunggah',
      uploadFailed: 'Gagal mengunggah',
      generateImage: 'Buat gambar',
      generatingImage: 'Membuat gambar',
      imageGenerated: 'Gambar dibuat dan disimpan sebagai aset',
      imageGenerationFailed: 'Gagal membuat gambar',
      image_purpose: 'Kegunaan gambar',
      image_purpose_asset: 'Aset umum',
      image_purpose_portrait_cover: 'Sampul vertikal',
      portrait_cover_hint: 'Membuat sampul 9:16 (1080 × 1920). Setelah selesai, pilih sebagai sampul vertikal di pengaturan cerita.',
      imagePrompt: 'Deskripsi gambar',
      imagePromptHint: 'Seedream akan membuat satu gambar 2K dan menyimpannya ke paket ini.',
      deleted: 'Aset dihapus',
      delete: 'Hapus aset',
      deleteFailed: 'Gagal menghapus',
      openFile: 'Buka file',
      inspect: 'Periksa',
      inspector: 'Pemeriksa aset',
      selectAsset: 'Pilih aset untuk melihat pratinjau, metadata, dan referensi.',
      noPreview: 'Tidak ada pratinjau',
      noMetadata: 'Tidak ada metadata',
      loading: 'Memuat aset',
      loadFailed: 'Gagal memuat aset',
      emptyTitle: 'Unggah potret atau CG pertama',
      empty: 'Belum ada aset',
      duplicateTag: 'Tag ini sudah ada. Gunakan tag unik.',
      referenceCount: '{count} referensi',
      references: 'Referensi',
      noReferences: 'Belum ada section yang memakai aset ini.',
      confirmDeleteTitle: 'Hapus aset',
      confirmDeleteBody: 'Aset ini akan dihapus dari draf saat ini.',
      confirmReferencedDeleteBody: 'Aset ini dipakai di {count} tempat. Referensi akan rusak setelah dihapus.',
      confirmTextLabel: 'Ketik {tag} untuk konfirmasi',
      confirmDeleteCta: 'Hapus aset',
      coverage: {
        total: 'Total aset',
        referenced: 'Dipakai di cerita',
        unreferenced: 'Belum dipakai',
        unreferencedTags: 'Tag aset belum dipakai',
        none: 'Semua aset sudah dipakai oleh field cerita.',
      },
      filters: { all: 'Semua' },
      groups: { cg: 'CG dan cutscene', character: 'Karakter dan potret', scene: 'Scene dan referensi', audio: 'Musik dan SFX', ui: 'Aset UI', reference: 'Gambar referensi', other: 'File lain' },
      types: { image: 'Gambar', video: 'Video', audio: 'Audio', asset: 'File' },
      meta: { type: 'Tipe', mime: 'MIME', dimensions: 'Dimensi', objectKey: 'Object key', hash: 'Hash' },
    },
    versions: { title: 'Versi', subtitle: 'Kompilasi, validasi, rilis, rollback, dan pratinjau.', compile: 'Kompilasi draf', compiling: 'Mengompilasi', compileDone: 'Kompilasi selesai', compileFailed: 'Gagal kompilasi', loadChecksFailed: 'Gagal memuat cek rilis', publishDone: 'Versi dirilis', publishFailed: 'Gagal rilis', previewFailed: 'Gagal mengotorisasi pratinjau', rollback: 'Rollback', rollbackDone: 'Rollback selesai', rollbackFailed: 'Gagal rollback', checks: 'Cek rilis', noChecks: 'Belum ada cek untuk versi ini. Kompilasi draf atau pilih versi.', version: 'Versi', emptyTitle: 'Belum ada versi', empty: 'Belum ada versi. Kompilasi draf dulu.', publishBlocked: 'Perbaiki cek yang memblokir sebelum rilis.', jumpToSection: 'Buka section', snapshot: 'Snapshot kompilasi', openSnapshot: 'Lihat snapshot', closeSnapshot: 'Tutup snapshot', noSnapshot: 'Versi ini belum memiliki snapshot kompilasi untuk ditampilkan.', checkStatus: { ok: 'Lulus', warning: 'Peringatan', error: 'Error', empty: 'Belum ada cek' }, checkSummary: { ok: 'Semua cek lulus.', warning: '{warnings} peringatan perlu ditinjau.', error: '{errors} cek memblokir rilis.', empty: 'Belum ada cek dimuat.' }, confirm: { publishTitle: 'Rilis versi', publishBody: 'Setelah rilis, aplikasi pemain memakai versi ini sebagai versi live.', publishCta: 'Rilis', rollbackTitle: 'Rollback versi', rollbackBody: 'Rollback mengganti versi live ke versi terpilih. Data pemain yang ada tidak dihapus.', rollbackAcknowledge: 'Saya paham versi live akan diganti dan ingin melanjutkan.', rollbackCta: 'Rollback' } },
    localization: { title: 'Lokalisasi konten game', description: 'Buat atau perbarui tiap bahasa secara manual untuk versi yang dipilih. Menyimpan draf tidak memulai terjemahan.', externalNotice: 'Saat dibuat, teks cerita versi ini dikirim ke model terjemahan yang dikonfigurasi dan hasilnya disimpan di tabel terjemahan.', sourceSummary: 'Versi ini memiliki {count} teks yang dapat diterjemahkan.', loading: 'Memuat status terjemahan…', loadFailed: 'Gagal memuat status terjemahan', generate: 'Buat terjemahan', generateAll: 'Buat semua bahasa ({count})', generatingAll: 'Membuat semua bahasa…', batchProgress: 'Memproses bahasa {current} dari {total} · {completed} selesai', generateAllDone: 'Terjemahan untuk {count} bahasa selesai', generateAllFailed: 'Terjemahan massal selesai: {completed} berhasil, {failed} gagal', allAlreadyDone: 'Semua bahasa sudah selesai', regenerate: 'Buat ulang', generating: 'Memproses…', generateDone: 'Terjemahan selesai dibuat', generateFailed: 'Gagal membuat terjemahan', progressStatus: { idle: 'Menyiapkan', translating: 'Menerjemahkan', saving: 'Menyimpan', completed: 'Selesai', failed: 'Gagal' }, status: { source: 'Bahasa sumber', missing: 'Menunggu', ready: 'Selesai' }, locales: { 'zh-CN': 'Tionghoa Sederhana', en: 'Inggris', ja: 'Jepang', ko: 'Korea', es: 'Spanyol', pt: 'Portugis' } },
    translationInventory: { title: 'Detail konten', all: 'Semua', pending: 'Perlu diterjemahkan', reused: 'Dipakai ulang', translated: 'Sudah diterjemahkan', source: 'Teks sumber', target: 'Terjemahan target', notTranslated: 'Belum diterjemahkan', empty: 'Tidak ada konten untuk filter ini.', reuseFrom: 'Konten tanpa perubahan akan dipakai ulang dari {version}.', reusableCount: '{count} dapat dipakai ulang', pendingCount: '{count} menunggu' },
    common: { retry: 'Coba lagi', refresh: 'Muat ulang', open: 'Buka', close: 'Tutup', more: 'Lainnya', required: 'Wajib' },
  },
}
